import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import Header from './components/Header/Header';
import LandingPage from './components/LandingPage/LandingPage';
import ShopPage from './components/ShopPage/ShopPage';
import ResumePage from './components/ResumePage/ResumePage';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { StateProvider } from './components/utilities/StateProvider';
import WarningPage from './components/WarningPage/WarningPage';

function App() {

  const initialState = {
    cart: {},
    event: {},
    user: {},
    isInterior: false
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'setCart':
        return {
          ...state,
          cart: action.cart
        }
      case 'setEvent':
        return {
          ...state,
          event: action.event
        }
      case 'setUser':
        return {
          ...state,
          user: action.user
        }
      case 'setInterior':
        return {
          ...state,
          isInterior: action.isInterior
        }
      default:
        return state;
    }
  }

  return (
    <div className="App">
      <Router>
        <StateProvider initialState={initialState} reducer={reducer}>
          <Header location="" />
          <div style={{overflowX: 'hidden'}}>
            <Route path="/" exact component={LandingPage} />
            <Route path="/shop" component={ShopPage} />
            <Route path="/resume" component={ResumePage} />
            <Route path="/warning" component={WarningPage} />
          </div>
        </StateProvider>
      </Router>
    </div>
  );
}

export default App;
